<template>
  
    <div id="personal_upstander" class="wrapper min-vh-100 position-relative">
        <div v-if="items" class="container ">
          
          <div class="row justify-content-center min-vh-100">
            <div class="col-10 bottom-pad">
            <div v-for="i in items" :key="i.id">
              <h2 class="guide-text text-center my-5">{{ $t(iKey('personal_upstander_section', i, 'label')) }}</h2>

              <div class="form-field">
                <div id="roles_dropzone" class="dropzone" ref="role" tabindex="0" ></div>
                {{ $t(iKey('personal_upstander_section', i, 'roles_sentence')) }}
              </div>
              
              <transition name="slide-fade" v-on:after-enter="afterEnter">
              <div v-if="role.dropped" class="form-field">
                {{ $t(iKey('personal_upstander_section', i, 'strengths_sentence')) }}
                <div id="roles_dropzone" class="dropzone med" ref="strength" tabindex="0"></div>
              </div>
              </transition>
              
              <transition name="slide-fade" v-on:after-enter="afterEnter">
              <div v-if="strength.dropped" class="form-field">
                {{ $t(iKey('personal_upstander_section', i, 'changes_sentence')) }}<br>
                <div id="roles_dropzone" class="dropzone long" ref="change" tabindex="0"></div>
              </div>
              </transition>
            
              <transition name="slide-fade">
              <ul v-if="!role.dropped">
                <DraggableTerm v-for="(term, index) in i.value.roles" 
                  :key="'role_' + index" 
                  :term="term" 
                  :dropzone="'role'"
                  @dragged="termDragged" 
                  @dropped="termDropped"
                  @clicked="termClicked"></DraggableTerm>
              </ul>
              </transition>
                
              <transition name="slide-fade-later">
              <ul v-if="role.dropped & !strength.dropped">
                <DraggableTerm v-for="(term, index) in i.value.strengths" 
                  :key="'strength_' + index" 
                  :term="term" 
                  :dropzone="'strength'"
                  @dragged="termDragged" 
                  @dropped="termDropped"
                  @clicked="termClicked"></DraggableTerm>
              </ul>
              </transition>
                
              <transition name="slide-fade-later">
              <ul v-if="strength.dropped & !change.dropped">
                <DraggableTerm v-for="(term, index) in i.value.changes" 
                  :key="'change_' + index" 
                  :term="term" 
                  :dropzone="'change'"
                  @dragged="termDragged" 
                  @dropped="termDropped"
                  @clicked="termClicked"></DraggableTerm>
              </ul>
              </transition>

              </div>
            </div>
          </div>
          
        </div>
        <div v-if="items" class="text-center py-5 reset-wrap">
          <button v-on:click="resetForm" class="btn-reset clear-form guide-text2">
            {{ $t(iKey('personal_upstander_section', items[0], 'reset_label')) }}
          </button>
        </div>
    </div>
  
</template>

<script>
import { i18nKey } from '@/services/i18n/i18n.js'
import DraggableTerm from '@/components/personal_upstander/DraggableTerm'

export default {
  name: 'PersonalUpstander',
  data: function() {
    return {
      role: {
        dropped: false,
        inbounds: false
      },
      strength: {
        dropped: false,
        inbounds: false
      },
      change: {
        dropped: false,
        inbounds: false
      }
    }
  },
  components: {
    DraggableTerm
  },
  props: [
    'items'
  ],
  methods: {
    iKey(section, obj, field){
      return i18nKey(section, obj, field)
    },
    termDragged(draggieRect, dropzone){
      var $ref = this.$refs[dropzone][0]
      var dzone = $ref.getBoundingClientRect()
      var dzone_center_x = dzone.left + (dzone.width / 2)
      var dzone_center_y = dzone.top + (dzone.height / 2)
      var drag_center_x = draggieRect.left + (draggieRect.width / 2)
      var drag_center_y = draggieRect.top + (draggieRect.height / 2)

      var in_range_x = Math.abs(dzone_center_x - drag_center_x) < 100
      var in_range_y = Math.abs(dzone_center_y - drag_center_y) < 50

      if(in_range_x & in_range_y){
        $ref.classList.add("active");
        this.$data[dropzone].inbounds = true
      } else {
        $ref.classList.remove("active");
        this.$data[dropzone].inbounds = false
      }
    },
    termDropped(draggie, dropzone){
      var $d =  this.$data[dropzone]
      var $dropz= this.$refs[dropzone][0]
      if($d.inbounds){
        $d.dropped = true;
        $dropz.innerHTML = draggie.innerHTML
        $dropz.classList.add("dropped")
        draggie.classList.add("dropped")

      } else {
        draggie.classList.remove("dropped")
      }
    },
    termClicked(draggie, dropzone){
      var $d =  this.$data[dropzone]
      $d.dropped = true;
      var $dropz= this.$refs[dropzone][0]

      $dropz.innerHTML = draggie.innerHTML
      $dropz.classList.add("dropped")
      draggie.classList.add("dropped")
    },
    afterEnter(el){
      el.getElementsByClassName("dropzone")[0].focus();
    },
    resetForm(){
      this.$data.role.dropped = false;
      this.$data.strength.dropped = false;
      this.$data.change.dropped = false;

      if(this.$refs.role){
        this.$refs.role[0].innerHTML = ""; 
        this.$refs.role[0].classList.remove("dropped") 
      }
    }
  },
  mounted(){

    // var dur = this.windowHeight
    // const scene = this.$scrollmagic.scene({
    //     triggerElement: '#personal_upstander',
    //     triggerHook: 0,
    //     duration: dur
    // })
    // this.$scrollmagic.addScene(
    //   scene
    //       .setPin('#personal_upstander')
    //       //.addIndicators({name: 'Scene 3'})
    // )  
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
    background-color: #ffd93d;
}
.dropzone {
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: white;
  border: 3px solid black;
  transition: border-color 0.3s;
  display: inline-block;
}

@media (min-width: 992px) { 
  .dropzone {
    width: 300px;
  }
  .dropzone.med {
    width: 400px;
  }
  .dropzone.long {
    width: 600px;
  }
}
.dropzone.active {
  border-color: white;
}
.dropzone.dropped {
  width: initial;
  height: auto;
}
.form-field {
  line-height: 60px;
  /* display: inline; */
}
@media (min-width: 578px) { 
  .form-field {
    line-height: 70px;
  }
}
.reset-wrap {
  position: absolute;
  bottom: 30px;
  width: 100%;
}

button {
  text-decoration: underline;
}

.bottom-pad {
  margin-bottom: 150px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease 0.4s;
}
.slide-fade-later-enter-active {
  transition: all .3s ease 0.8s;
}
.slide-fade-leave-active,
.slide-fade-later-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter,
.slide-fade-later-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to,
.slide-fade-later-leave-to {
  opacity: 0;
}

</style>
